import { render } from "./ViewBtn.vue?vue&type=template&id=afa5a0a0"
import script from "./ViewBtn.vue?vue&type=script&lang=js"
export * from "./ViewBtn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmerkuloff/Web/hlv/FRONT/hpanel/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__